import { css } from 'styled-components';
import { ButtonColorDefinition as ButtonVariantDefinition } from './ButtonVariant';
import { ButtonSizeDefinition } from './ButtonSize';
import { Icon } from '../icon';

export const basicButtonStyling = css`
  align-items: center;
  justify-content: center;
  transition: background 0.16s, border 0.16s, color 0.16s;
  font-family: ${props => props.theme.font};
  position: relative;
  border-radius: 2px;
  .icon {
    transition: color 0.16s;
  }

  .icon:before {
    vertical-align: baseline;
  }
`;

export const sizeDependantStyling = (hasLabel: boolean, sizeDefinition: ButtonSizeDefinition) => css`
  line-height: ${sizeDefinition.lineHeight}px;
  padding: ${hasLabel
		? `${sizeDefinition.paddingVertical}px ${sizeDefinition.paddingHorizontal}px`
		: `${sizeDefinition.paddingNoLabel}px`};
  gap: ${sizeDefinition.gap}px;
  font-size: ${sizeDefinition.fontSize}px;
  min-width: ${sizeDefinition.minSize ? `${sizeDefinition.minSize}px` : 'auto'};
  min-height: ${sizeDefinition.minSize ? `${sizeDefinition.minSize}px` : 'auto'};
`;

export const variantStyling = (
	variantDefinition: ButtonVariantDefinition,
	textButton: boolean,
	active?: boolean,
	$rounded?: boolean,
) =>
	css`
		${$rounded && css`
			border-radius: 30px;
		`}
      ${variantDefinition.border ? css`
        border-width: 1px;
        border-style: solid;
      ` : css`
        border: none;
      `}
      ${active ? css`
        color: ${variantDefinition.color.active};
        background: ${variantDefinition.background.active};
        ${variantDefinition.border && css`
          border-color: ${variantDefinition.border.active};
        `}
          & ${Icon.cssSelector} {
            color: ${variantDefinition.icon.active};
          }
      ` : css`
        color: ${variantDefinition.color.default};
        background: ${variantDefinition.background.default};
        ${variantDefinition.border && css`
          border-color: ${variantDefinition.border.default};
        `}
          & ${Icon.cssSelector} {
            color: ${variantDefinition.icon.default};
          }
      `}
      &:hover,
      &.hover {
        color: ${variantDefinition.color.hover};
        background: ${variantDefinition.background.hover};
        ${variantDefinition.border && css`
          border-color: ${variantDefinition.border.hover};
        `}
        ${textButton && css`
          & span:not(.icon) {
            text-decoration: underline;
            text-underline-offset: 3px;
          }
        `}
          & ${Icon.cssSelector} {
            color: ${variantDefinition.icon.hover};
          }
      }

      // Disabled comes first so active can properly restyle
      &.disabled,
      &[disabled],
      &:disabled {
        opacity: ${variantDefinition.opacity};
        color: ${variantDefinition.color.disabled};
        background: ${variantDefinition.background.disabled};
        ${variantDefinition.border && css`
          border-color: ${variantDefinition.border?.disabled};
        `}
          & ${Icon.cssSelector} {
            color: ${variantDefinition.icon.disabled};
          }
      }

      &:not(:disabled):not(.disabled):active,
      &:not(:disabled):not(.disabled).active {
        color: ${variantDefinition.color.active};
        background: ${variantDefinition.background.active};
        ${variantDefinition.border && css`
          border-color: ${variantDefinition.border?.active};
        `}
          & ${Icon.cssSelector} {
            color: ${variantDefinition.icon.active};
          }
      }
    }
    `;
